var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.question)?_c('div',[_c('v-checkbox',{attrs:{"label":"Multiple"},model:{value:(_vm.question.multiple),callback:function ($$v) {_vm.$set(_vm.question, "multiple", $$v)},expression:"question.multiple"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }